<template>
  <li role="presentation" :aria-label="label">
    <a
      :href="href"
      :target="target"
      :title="label"
      :class="{ 'i-state-disabled': !enabled }"
      v-bind="$attrs"
    >
      <i class="fas" :class="`fa-${icon}`" :name="icon"></i>
      <span>{{ label }}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: 'i-menu-action',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    href: {
      type: String,
      default: '#',
    },
    target: {
      type: String,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style scoped lang='scss'>
li {
  margin: 1px 0;
  a {
    font-family: $font-family-regular;
    color: $black;
    display: inline-block;
    width: 100%;
    font-size: 13px;
    height: 32px;
    line-height: 32px;
    padding: 0 30px 0 15px;
    white-space: nowrap;

    &:hover {
      background-color: $hover_blue_light;
      color: $blue;
    }

    i {
      color: $blue;
      margin-right: 10px;
      font-size: 16.5px;
      line-height: 17px;
      width: 15px;
      vertical-align: middle;
    }
  }
}
</style>
